import { uploadFile, getProtected, postProtected } from './utils';

export var getKyc = function getKyc(playerSessionID) {
  return getProtected('/kyc', playerSessionID);
};

export var upload = function upload(playerSessionID, data) {
  return uploadFile('/kyc/upload', data, playerSessionID);
};

export var sourceOfWealth = function sourceOfWealth(playerSessionID, data) {
  return postProtected('/kyc/source-of-wealth', playerSessionID, data);
};

export var sourceOfWealthV2 = function sourceOfWealthV2(playerSessionID, data) {
  return postProtected('/kyc/source-of-wealth/v2', playerSessionID, data);
};

export default {
  getKyc: getKyc,
  upload: upload,
  sourceOfWealth: sourceOfWealth,
  sourceOfWealthV2: sourceOfWealthV2
};